// src/pages/BusinessProfileFull.tsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getBusiness } from "../utils/publicApi";
import { toAbsoluteUrl } from "../utils/url";
import "./BusinessProfileFull.scss";

/* Icons */
const IconStar = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="currentColor" d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
  </svg>
);
const IconPhone = () => (
  <svg width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1V21a1 1 0 01-1 1C10.07 22 2 13.93 2 3a1 1 0 011-1h3.49a1 1 0 011 1c0 1.24.2 2.45.57 3.57a1 1 0 01-.24 1.02l-2.2 2.2z"/></svg>
);
const IconGlobe = () => (
  <svg width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2a10 10 0 100 20 10 10 0 000-20m-1 17.93A8.001 8.001 0 014.07 13H7c.11 2 .77 3.87 1.79 5.32c.39.55.81 1.02 1.21 1.37M4.07 11A8.001 8.001 0 0111 4.07V6c-2 .11-3.87.77-5.32 1.79c-.55.39-1.02.81-1.61 1.21M13 4.07A8.001 8.001 0 0119.93 11H18c-.11-2-.77-3.87-1.79-5.32c-.39-.55-.81-1.02-1.21-1.61M19.93 13A8.001 8.001 0 0113 19.93V18c2-.11 3.87-.77 5.32-1.79c.55-.39 1.02-.81 1.61-1.21Z"/></svg>
);
const IconLocation = () => (
  <svg width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7m0 9.5A2.5 2.5 0 119.5 9A2.5 2.5 0 0112 11.5"/></svg>
);

/* Social icons */
const IconFacebook = () => (
  <svg width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M22 12.06C22 6.51 17.52 2 12 2S2 6.51 2 12.06C2 17.08 5.66 21.2 10.44 22v-7.02H7.9v-2.92h2.54V9.41c0-2.5 1.49-3.88 3.77-3.88c1.09 0 2.23.2 2.23.2v2.45h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.44 2.92h-2.34V22C18.34 21.2 22 17.08 22 12.06z"/></svg>
);
const IconInstagram = () => (
  <svg width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm5 3.5A5.5 5.5 0 1 1 6.5 13A5.5 5.5 0 0 1 12 7.5m0 2A3.5 3.5 0 1 0 15.5 13A3.5 3.5 0 0 0 12 9.5m5.25-3a1.25 1.25 0 1 1-1.25 1.25A1.25 1.25 0 0 1 17.25 6.5"/></svg>
);
const IconTikTok = () => (
  <svg width="16" height="16" viewBox="0 0 256 256"><path fill="currentColor" d="M168.6 32c8.7 17.1 23.4 30.7 41.4 37.7V96c-16.4 0-31.6-5.1-44.1-13.8v60.3c0 37.1-30.2 67.5-67.5 67.5S30.9 179.6 30.9 142.5S61.1 75 98.4 75c6.4 0 12.6 1 18.4 2.9v34.3c-5.5-2.8-11.7-4.4-18.4-4.4c-21.7 0-39.3 17.6-39.3 39.3s17.6 39.3 39.3 39.3s39.3-17.6 39.3-39.3V32z"/></svg>
);
const IconWhatsApp = () => (
  <svg width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M20.52 3.48A11.86 11.86 0 0 0 12.03 0A12 12 0 0 0 1.79 16.32L0 24l7.87-1.77a11.97 11.97 0 0 0 4.16.75h.01A12 12 0 0 0 24 12a11.86 11.86 0 0 0-3.48-8.52M12.04 21.3h-.01c-1.34 0-2.66-.35-3.83-1.01l-.27-.16l-4.67 1.05l1-4.56l-.18-.28a9.23 9.23 0 0 1 15.28-10.12a9.23 9.23 0 0 1-7.32 15.08m5.2-6.94c-.28-.14-1.66-.82-1.91-.91s-.44-.14-.62.14s-.71.91-.87 1.09s-.32.21-.6.07a7.52 7.52 0 0 1-2.21-1.36a8.32 8.32 0 0 1-1.54-1.91c-.16-.28 0-.43.12-.57l.34-.4c.14-.16.2-.27.3-.46s.05-.35-.02-.49s-.62-1.49-.85-2.03s-.45-.46-.62-.47h-.53a1 1 0 0 0-.7.34c-.24.25-.91.9-.91 2.2s.93 2.54 1.07 2.71c.14.16 1.83 2.8 4.44 3.93c.62.27 1.1.43 1.48.55c.62.2 1.18.17 1.63.1c.5-.08 1.66-.68 1.9-1.34c.24-.65.24-1.21.17-1.34s-.26-.2-.54-.34"/></svg>
);

const BusinessProfileFull: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [data, setData] = useState<any>(null);
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const d = await getBusiness(slug!);
        if (!alive) return;
        setData(d);
        // console logs to confirm payload shape
        console.log("business", d?.business);
        console.log("publicProfile (if present)", (d as any)?.business?.publicProfile);
      } catch (e: any) {
        if (alive) setErr(e?.message || "Erreur de chargement.");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [slug]);

  if (err) return <div className="bpfull container"><div className="error">{err}</div></div>;

  if (loading || !data) {
    return (
      <div className="bpfull container">
        <div className="skeleton hero" />
        <div className="skeleton card" />
        <div className="skeleton card" />
      </div>
    );
  }

  const b = data.business || {};

  // Optional shapes:
  const pp = ((b as any)?.publicProfile ?? {}) as Partial<{
    facebook: string; instagram: string; tiktok: string; whatsapp: string;
    website: string; phonePublic: string; addressStreet: string; addressZip: string;
    addressCity: string; addressCountry: string; tagline: string; description: string;
    hoursText: string; categories: string[]; coverUrl: string; logoUrl: string; slug: string;
  }>;

  const socials = ((b as any)?.socials ?? (pp as any)?.socials ?? {}) as Partial<{
    facebook: string; instagram: string; tiktok: string; whatsapp: string; website: string;
  }>;

  const name: string = b.name || (pp as any).name || "";
  const logoUrl = pp.logoUrl || b.logoUrl || "";
  const coverUrl = pp.coverUrl || b.coverUrl || "";
  const site = toAbsoluteUrl(
    b.website || pp.website || socials.website || ""
  );
  const phone = pp.phonePublic || b.phonePublic || "";

  const address = [
    pp.addressStreet ?? b.addressStreet,
    [pp.addressZip ?? b.addressZip, pp.addressCity ?? b.addressCity].filter(Boolean).join(" "),
    pp.addressCountry ?? b.addressCountry
  ].filter(Boolean).join(", ");

  const tagline = pp.tagline || b.tagline || "";
  const description = pp.description || b.description || "";
  const hoursText = pp.hoursText || b.hoursText || "";
  const categories: string[] = Array.isArray(pp.categories)
    ? pp.categories
    : Array.isArray(b.categories)
    ? b.categories
    : [];

  const stats = data.stats || { avgRating: 0, totalReviews: 0 };

  // Socials (normalize across shapes)
  const fb = socials.facebook
    ? toAbsoluteUrl(socials.facebook)
    : (pp.facebook ? toAbsoluteUrl(pp.facebook) : (b.facebook ? toAbsoluteUrl(b.facebook) : ""));
  const ig = socials.instagram
    ? toAbsoluteUrl(socials.instagram)
    : (pp.instagram ? toAbsoluteUrl(pp.instagram) : (b.instagram ? toAbsoluteUrl(b.instagram) : ""));
  const tt = socials.tiktok
    ? toAbsoluteUrl(socials.tiktok)
    : (pp.tiktok ? toAbsoluteUrl(pp.tiktok) : (b.tiktok ? toAbsoluteUrl(b.tiktok) : ""));
  const wa = (socials.whatsapp || pp.whatsapp || b.whatsapp)
    ? `https://wa.me/${String(socials.whatsapp || pp.whatsapp || b.whatsapp).replace(/[^\d]/g, "")}`
    : "";

  const heroBg = coverUrl
    ? { backgroundImage: `linear-gradient(180deg, rgba(0,0,0,.25), rgba(0,0,0,.35)), url(${coverUrl})` }
    : { backgroundImage: `radial-gradient(1200px 400px at 0% 0%, #eef1f5, #f7f8fb)` };

  return (
    <div className="bpfull container">
      <section className="hero" style={heroBg} />

      <header className="headCard">
        {logoUrl ? (
          <img className="avatar" src={logoUrl} alt={`${name} logo`} />
        ) : (
          <div className="avatar placeholder">{(name || "?").slice(0, 1)}</div>
        )}

        <div className="headMain">
          <h1 className="title">{name}</h1>
          {tagline && <p className="tagline">{tagline}</p>}

          <div className="metaRow">
            {address && (
              <span className="metaItem">
                <IconLocation />
                {address}
              </span>
            )}
            {phone && (
              <a className="metaItem" href={`tel:${phone}`}>
                <IconPhone /> {phone}
              </a>
            )}
            {site && (
              <a className="metaItem" href={site} target="_blank" rel="noreferrer">
                <IconGlobe /> Site officiel
              </a>
            )}
          </div>

          <div className="pillRow">
            <div className="ratingPill" title="Note moyenne">
              <IconStar />
              <strong>{Number(stats.avgRating || 0).toFixed(1)}</strong>
              <span className="muted">/5 · {stats.totalReviews} avis</span>
            </div>

            <Link className="btn solid" to={`/b/${pp.slug || b.slug || b.id}`}>
              Voir la page avis
            </Link>
          </div>
        </div>
      </header>

      <div className="grid">
        <div className="col">
          {description && (
            <section className="card">
              <h2>À propos</h2>
              <p className="about">{description}</p>
            </section>
          )}

          {hoursText && (
            <section className="card">
              <h2>Horaires</h2>
              <pre className="hours">{hoursText}</pre>
            </section>
          )}
        </div>

        <aside className="col side">
          {!!(categories && categories.length) && (
            <section className="card">
              <h3>Catégories</h3>
              <div className="chips">
                {categories.map((c: string) => (
                  <span key={c} className="chip">{c}</span>
                ))}
              </div>
            </section>
          )}

          {(fb || ig || tt || wa) && (
            <section className="card socials">
              <h3>Réseaux sociaux</h3>
              <div className="socialsRow">
                {fb && (
                  <a className="social fb" href={fb} target="_blank" rel="noreferrer">
                    <IconFacebook /> Facebook
                  </a>
                )}
                {ig && (
                  <a className="social ig" href={ig} target="_blank" rel="noreferrer">
                    <IconInstagram /> Instagram
                  </a>
                )}
                {tt && (
                  <a className="social tt" href={tt} target="_blank" rel="noreferrer">
                    <IconTikTok /> TikTok
                  </a>
                )}
                {wa && (
                  <a className="social wa" href={wa} target="_blank" rel="noreferrer">
                    <IconWhatsApp /> WhatsApp
                  </a>
                )}
              </div>
            </section>
          )}
        </aside>
      </div>
    </div>
  );
};

export default BusinessProfileFull;
